// src/pages/SubCategoryPage.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../contexts/CartContext';
import { LocationContext } from '../contexts/LocationContext';
import Header from '../components/layout/Header';

// Importation des images
import sodaBottlesImage from '../assets/images/soda-bottles.png';
import waterBottlesImage from '../assets/images/water-bottles.png';
//import otherBottlesImage from '../assets/images/other-bottles.png';

// Importation du CSS spécifique
import '../styles/subcategory.css';
import SEOHead from '../components/SEO/SEOHead';

const SubCategoryPage = () => {
  const navigate = useNavigate();
  const { getTotalItems } = useContext(CartContext);
  const { userLocation, nearestDistributor, calculateDistance } = useContext(LocationContext);
  
  const [distance, setDistance] = useState(null);
  
  // Calculer la distance avec le distributeur le plus proche
  useEffect(() => {
    if (userLocation && nearestDistributor) {
      const distanceKm = calculateDistance(
        userLocation.latitude,
        userLocation.longitude,
        nearestDistributor.latitude,
        nearestDistributor.longitude
      );
      setDistance(distanceKm);
    }
  }, [userLocation, nearestDistributor, calculateDistance]);
  
  const handleSubCategorySelect = (subcategory) => {
    navigate(`/products/${subcategory}`);
  };
  
  return (
    <div className="subcategory-page">
    <SEOHead
      title="Sous-catégories"
      description="Affinez votre sélection de boissons par type et marque."
      canonical="https://bccv.online/subcategories"
    />
      <Header 
        title="EAUX ET BOISSONS GAZEUSES" 
        showBackButton={true} 
		onBackClick={() => navigate('/prototype-categories')}
      />
      
      {/* Bannière du distributeur */}
      {nearestDistributor && (
        <div className="distributor-banner">
          <svg viewBox="0 0 24 24" className="distributor-icon" width="20" height="20" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          </svg>
          <div className="distributor-details">
            <div className="distributor-name">{nearestDistributor.nom || "Distributeur"}</div>
            {distance !== null && (
              <div className="distributor-distance">À {distance.toFixed(1)} km de vous</div>
            )}
          </div>
        </div>
      )}
      
      <div className="subcategory-content">
        <h2 className="subcategory-title">
          Choisissez une sous catégorie
        </h2>
        
        <div className="subcategory-cards">
          {/* Carte Boissons Gazeuses */}
          <div 
            className="card-soda"
            onClick={() => handleSubCategorySelect('sodas')}
          >
            <div className="card-image-area">
              <img src={sodaBottlesImage} alt="Boissons gazeuses" />
            </div>
            <div className="card-content">
              <div className="card-title-soda">
                <span className="title-part1">BOISSONS</span>
                <span className="title-part2">GAZEUSES</span>
              </div>
              <p className="card-description">
                Top, World Cola, Orangina, Vimto, etc.
              </p>
              <div className="selection-badge">
                2 sélectionnés (s)
              </div>
            </div>
          </div>
          
          {/* Carte Eaux Minérales */}
          <div 
            className="card-water"
            onClick={() => handleSubCategorySelect('eaux')}
          >
            <div className="card-image-area">
              <img src={waterBottlesImage} alt="Eaux minérales" />
            </div>
            <div className="card-content">
              <div className="card-title-water">
                <span className="title-part1">EAUX</span>
                <span className="title-part2">MINÉRALES</span>
              </div>
              <p className="card-description">
                Tangui, Vitale
              </p>
              <div className="selection-badge">
                1 sélectionné (s)
              </div>
            </div>
          </div>
          
          {/* Carte Autres Boissons (optionnelle) */}
          </div>
      </div>
      
      {/* Bouton du panier (visible uniquement si non vide) */}
      {getTotalItems() > 0 && (
        <div className="cart-button-container">
          <button 
            className="cart-button"
            onClick={() => navigate('/cart')}
          >
            <svg className="cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 20a1 1 0 11-2 0 1 1 0 012 0zm9 0a1 1 0 11-2 0 1 1 0 012 0zM3 3h2l.4 2M7 13h10l4-8H5.4L3 3" />
            </svg>
            Voir mon casier
            <span className="cart-badge">
              {getTotalItems()}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SubCategoryPage;